/** @format */

/**
* @typedef {object} ORDER_STATUS - read from order partner
 * @property {string} RESERVED
 * @property {string} FAILED
 * @property {string} PENDING - default status
 * @property {string} DELETED
 * @property {string} REFUNDED - read from order
 * @property {boolean} PAST_BOOKING - read from order

* @typedef {object} ORDER_STATUS_TYPES
 * @property {string} color - color of status
 * @property {string} i18nKeyLabel - key of i18n label
 * @property {string} value - value of order type
 */

/** @type {ORDER_STATUS} */
export const ORDER_STATUS = {
    RESERVED: {
        color: 'success',
        i18nKeyLabel: 'confirmed',
        value: 'RESERVED',
    },
    FAILED: {
        color: 'warning',
        i18nKeyLabel: 'failed',
        value: 'FAILED',
    },
    PENDING: {
        color: 'warning',
        i18nKeyLabel: 'pending',
        value: 'PENDING',
    },
    DELETED: {
        color: 'warning',
        i18nKeyLabel: 'deleted',
        value: 'DELETED',
    },
    // TODOMMH: Refactor status chip and create 2 separated files for statuses (order/orderPartner)
    REFUNDED: {
        color: 'warning',
        i18nKeyLabel: 'refunded',
        value: 'REFUNDED',
    },
    PAST_BOOKING: {
        color: 'septenary',
        i18nKeyLabel: 'pastBooking',
        value: 'PAST_BOOKING',
    },
};
